export const ELECTRICITY_BILL_VALUE = 'Electricity Bill';

export const PROOF_OF_ADDRESS_OPTIONS = [
  { label: 'Electricity Bill', value: ELECTRICITY_BILL_VALUE },
  { label: 'Water Bill', value: 'Water Bill' },
  { label: 'Waste Bill', value: 'Waste Bill' },
  { label: 'Bank Statement', value: 'Bank Statement' },
  { label: 'Government Issued Document', value: 'Government Issued Document' },
  {
    label: 'Estate or Service Apartment Receipt',
    value: 'Estate or Service Apartment Receipt',
  },
  {
    label: 'Sworn Affidavit Confirming Address',
    value: 'Sworn Affidavit Confirming Address',
  },
  {
    label: 'Declaration of Address Duly Notarized by a Notary Public',
    value: 'Declaration of Address Duly Notarized by a Notary Public',
  },
  { label: 'Land Use Charge Receipt', value: 'Land Use Charge Receipt' },
  { label: 'Executed Tenancy Agreement', value: 'Executed Tenancy Agreement' },
];
